import React, { FC, ReactNode, useEffect, useRef } from 'react';
import Button from '../../../../../ui/button/button';
import CurrencyPrice from '../../../../../common/currency-price/currency-price';
import { BUTTON_VARIANTS } from '../../../../../constants/button-variants';
import translation from '../../../../../languages';
import qualityEvents from '../../../../../services/quality-events/quality-events';
import cn from '../../../../../utils/classnames';
import usePlacement from './use-placement';
import './mobile-checkout-block.scss';

type MobileCheckoutBlockProps = TranslationProps & {
    goToPaymentPage: () => void;
    totalPrice: string;
    hasCartItems: boolean;
    children?: ReactNode;
};

const MobileCheckoutBlock: FC<MobileCheckoutBlockProps> = (props) => {
    const { goToPaymentPage, totalPrice, children, hasCartItems, t } = props;

    const checkoutBlockRef = useRef<HTMLDivElement | null>(null);
    const wrapperRef = useRef<HTMLDivElement | null>(null);

    const position = usePlacement({ wrapperRef });

    const handleCheckoutButtonClick = () => {
        qualityEvents.cartPage.goToPaymentMobile(goToPaymentPage);
    };

    useEffect(() => {
        const checkoutBlock = checkoutBlockRef.current;
        const wrapper = wrapperRef.current;

        const bothBlocksExist = checkoutBlock && wrapper;

        if (!bothBlocksExist) {
            return;
        }

        const observer = new ResizeObserver(() => {
            const checkoutBlockHeight = checkoutBlock.clientHeight;

            wrapper.style.height = `${checkoutBlockHeight}px`;
        });

        observer.observe(checkoutBlock);

        return () => observer.disconnect();
    }, []);

    return (
        <div ref={wrapperRef} className='checkout-block-wrapper'>
            <div ref={checkoutBlockRef} className={cn('checkout-block', position)}>
                <span className='checkout-total'>{t('cart.cartSummary.sumDesc')}</span>

                <div className='checkout-price'>
                    <CurrencyPrice price={totalPrice} />
                </div>

                <span className='checkout-vat'>{t('cart.cartSummary.includesTax')}</span>

                {hasCartItems && (
                    <Button
                        className='checkout-button'
                        onClick={handleCheckoutButtonClick}
                        variant={BUTTON_VARIANTS.YELLOW}
                    >
                        {t('cart.cartSummary.goToPayment')}
                    </Button>
                )}

                {children}
            </div>
        </div>
    );
};

const translate = translation('cart');

export default translate(MobileCheckoutBlock);
